/* Urban Calm lightweight global interaction core. Impulse 9.2.0. */
(function(){
  'use strict';
  /* Impulse 9.2.0 compatibility patch. Verify modal focus return after every theme upgrade. */
  function patchModalFocus(){
    var Modal=window.theme&&window.theme.Modals;
    if(!Modal||!Modal.prototype||Modal.prototype.__ucFocusPatched)return;
    var originalOpen=Modal.prototype.open;
    var originalClose=Modal.prototype.close;
    Modal.prototype.open=function(evt){
      if(evt&&evt.currentTarget)this.__ucActiveSource=evt.currentTarget;
      return originalOpen.apply(this,arguments);
    };
    Modal.prototype.close=function(){
      var opener=this.__ucActiveSource;
      var shouldRestore=!!(this.modalIsOpen&&opener);
      var result=originalClose.apply(this,arguments);
      if(shouldRestore){
        this.__ucActiveSource=null;
        window.setTimeout(function(){
          opener.setAttribute('aria-expanded','false');
          if(document.contains(opener)&&!document.querySelector('.modal--is-active'))opener.focus();
        },520);
      }
      return result;
    };
    Modal.prototype.__ucFocusPatched=true;
  }
  patchModalFocus();
})();

/* Load cart/product enhancements only when they can be useful. */
(function(){
  'use strict';
  var current=document.currentScript||document.querySelector('script[src*="uc-modern.js"]');
  var src=current&&current.src?current.src:'';
  function sibling(filename){
    if(!src)return'';
    return src.replace(/uc-modern\.js(?=\?|$)/,filename);
  }
  function load(id,url){
    if(!url||document.getElementById(id))return;
    var script=document.createElement('script');
    script.id=id;
    script.src=url;
    script.async=true;
    document.head.appendChild(script);
  }
  var cartSrc=sibling('uc-cart-enhancements.js');
  var productSrc=sibling('uc-product-enhancements.js');
  var body=document.body;
  if(body&&body.classList.contains('template-product'))load('ucProductEnhancementsScript',productSrc);
  if(body&&body.classList.contains('template-cart'))load('ucCartEnhancementsScript',cartSrc);
  else {
    var loadCart=function(){load('ucCartEnhancementsScript',cartSrc)};
    document.addEventListener('cart:open',loadCart,{once:true});
    document.addEventListener('cart:build',loadCart,{once:true});
    document.addEventListener('cart:updated',loadCart,{once:true});
    document.addEventListener('ajaxProduct:added',loadCart,{once:true});
  }
})();

/* Predictive-search cleanup for excluded legacy Learning Centre articles. */
(function(){
  'use strict';
  function setup(host){
    if(!host||host.dataset.ucLegacyFilterReady==='true')return;
    host.dataset.ucLegacyFilterReady='true';
    var raw=host.getAttribute('data-uc-excluded-articles')||'';
    var excluded=new Set(raw.split('|').map(function(v){return v.trim()}).filter(Boolean));
    if(!excluded.size)return;
    function clean(root){
      root=root||host;
      root.querySelectorAll('a[href*="/blogs/"]').forEach(function(link){
        try{var path=new URL(link.href,window.location.origin).pathname.replace(/\/$/,'');var handle=path.split('/').pop();if(!excluded.has(handle))return;var item=link.closest('li,.grid__item');if(item)item.remove();else link.remove()}catch(e){}
      });
      root.querySelectorAll('.results--articles,[data-type-articles]').forEach(function(group){if(!group.querySelector('a[href*="/blogs/"]'))group.remove()});
    }
    clean(host);
    if(window.MutationObserver)new MutationObserver(function(){clean(host)}).observe(host,{childList:true,subtree:true});
  }
  function init(root){(root||document).querySelectorAll('predictive-search[data-uc-excluded-articles]').forEach(setup)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target||document)});
})();
